(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        const borderBox = entry?.borderBoxSize;
        const height = (Array.isArray(borderBox) ? borderBox[0]?.blockSize : borderBox?.blockSize) || entry?.target?.offsetHeight;
        if (height) document.documentElement.style.setProperty('--header-height', `${Math.round(height)}px`);
      });
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        const borderBox = entry?.borderBoxSize;
        const height = (Array.isArray(borderBox) ? borderBox[0]?.blockSize : borderBox?.blockSize) || entry?.target?.offsetHeight;
        if (height) document.documentElement.style.setProperty('--header-height', `${Math.round(height)}px`);
      });
      this.headerResizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoria-campaign-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zoria-campaign-countdown')) {
    customElements.define('zoria-campaign-countdown', class extends HTMLElement {
      connectedCallback() {
        const end = Date.parse(this.dataset.endAt);
        if (!Number.isFinite(end)) return;
        const update = () => {
          const remaining = end - Date.now();
          if (remaining <= 0) {
            this.hidden = true;
            clearInterval(this.timer);
            return;
          }
          const totalSeconds = Math.floor(remaining / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          this.textContent = `${days} ימים · ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          this.hidden = false;
        };
        update();
        if (!this.hidden) this.timer = setInterval(update, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoria-home"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.z-hero__video').forEach((video) => video.pause());
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoria-product-landing-preview"] && !Shopify.designMode) return;
  try {
    
  const placeZoriaBenefits = () => {
    const benefits = document.querySelector('.zlp__benefits');
    const form = document.querySelector('.product__info-container .main-product-form, .product__info-container .product-form');
    const formBlock = form?.parentElement;
    if (benefits && formBlock && benefits.previousElementSibling !== formBlock) formBlock.after(benefits);
  };

  placeZoriaBenefits();
  document.addEventListener('shopify:section:load', placeZoriaBenefits);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoria-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'zoria:recent-products:v1';
    const storageLimit = 8;
    const maxAge = 30 * 24 * 60 * 60 * 1000;
    const validHandle = (handle) => typeof handle === 'string'
      && handle.length <= 255
      && /^[\p{L}\p{N}][\p{L}\p{N}_-]*$/u.test(handle);

    const readHistory = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(parsed)) return [];
        const now = Date.now();
        return parsed.filter((entry) =>
          validHandle(entry?.handle)
          && Number.isFinite(Number(entry.viewedAt))
          && now - Number(entry.viewedAt) < maxAge
        );
      } catch {
        return [];
      }
    };

    const writeHistory = (history) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(history.slice(0, storageLimit)));
      } catch {}
    };

    const productUrl = (root, handle, json = false) => {
      const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
      return `${normalizedRoot}products/${encodeURIComponent(handle)}${json ? '.js' : ''}`;
    };

    const formatPrice = (amount, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'he-IL', {
          style: 'currency',
          currency,
        }).format(amount / 100);
      } catch {
        return `${(amount / 100).toFixed(2)} ${currency}`;
      }
    };

    const displayTitle = (product) => product.title || '';

    const createQuickAdd = (section, product, root) => {
      const template = section.querySelector('[data-zoria-recent-quick-add-template]');
      if (!template || !(template instanceof HTMLTemplateElement)) return null;

      const fragment = template.content.cloneNode(true);
      const opener = fragment.querySelector('modal-opener');
      const button = fragment.querySelector('.quick-add__submit');
      const modal = fragment.querySelector('quick-add-modal');
      const dialog = fragment.querySelector('[role="dialog"]');
      const close = fragment.querySelector('.quick-add-modal__toggle');
      const content = fragment.querySelector('.quick-add-modal__content-info');
      if (!opener || !button || !modal || !dialog || !close || !content) return null;

      const sectionId = section.dataset.sectionId || 'recent';
      const productId = Number.isFinite(Number(product.id)) ? String(product.id) : product.handle;
      const uniqueId = `${sectionId}-${productId}`.replace(/[^\p{L}\p{N}_-]/gu, '-');
      const modalId = `QuickAdd-Recent-${uniqueId}`;
      const productName = displayTitle(product);
      const dialogLabel = (section.dataset.chooseOptions || section.dataset.addToCart || '')
        .replace('__PRODUCT__', productName);

      opener.dataset.modal = `#${modalId}`;
      button.id = `QuickAdd-Recent-${uniqueId}-submit`;
      button.dataset.productUrl = productUrl(root, product.handle);
      button.setAttribute('aria-label', `${section.dataset.addToCart}: ${productName}`);
      modal.id = modalId;
      modal.dataset.zoriaRecentOwner = sectionId;
      dialog.setAttribute('aria-label', dialogLabel);
      close.id = `ModalClose-Recent-${uniqueId}`;
      content.id = `QuickAddInfo-Recent-${uniqueId}`;

      return fragment;
    };

    const createCard = (section, product, root) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      const media = document.createElement('div');
      const content = document.createElement('div');
      const title = document.createElement('h3');
      const imageSource = typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image?.src;
      item.className = 'zoria-recently-viewed__card';
      link.href = productUrl(root, product.handle);
      media.className = 'zoria-recently-viewed__media';
      content.className = 'zoria-recently-viewed__content';
      title.textContent = displayTitle(product);

      if (imageSource || section.dataset.demo === 'true') {
        const image = document.createElement('img');
        image.src = imageSource || section.dataset.fallbackImage;
        image.alt = displayTitle(product);
        image.width = 800;
        image.height = 1000;
        image.loading = 'lazy';
        media.appendChild(image);
        if (!imageSource) {
          const badge = document.createElement('span');
          badge.className = 'zoria-recently-viewed__badge';
          badge.textContent = section.dataset.demoLabel;
          media.appendChild(badge);
        }
        link.appendChild(media);
      }

      content.appendChild(title);
      const amount = Number(product.price);
      if (Number.isFinite(amount)) {
        const price = document.createElement('p');
        price.textContent = formatPrice(amount, section.dataset.currency);
        content.appendChild(price);
      }
      if (product.available === false) {
        const soldOut = document.createElement('p');
        soldOut.textContent = section.dataset.soldOut;
        content.appendChild(soldOut);
      }
      link.appendChild(content);
      item.appendChild(link);
      if (product.available !== false) {
        const quickAdd = createQuickAdd(section, product, root);
        if (quickAdd) item.appendChild(quickAdd);
      }
      return item;
    };

    const initSection = async (section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const currentHandle = section.dataset.currentHandle;
      if (!validHandle(currentHandle)) return;
      const history = readHistory();
      const previous = history
        .filter((entry) => entry.handle !== currentHandle)
        .slice(0, Number(section.dataset.maxProducts) || 4);
      writeHistory([
        { handle: currentHandle, viewedAt: Date.now() },
        ...history.filter((entry) => entry.handle !== currentHandle),
      ]);
      if (previous.length === 0) return;

      const root = window.Shopify?.routes?.root || '/';
      const products = (await Promise.all(previous.map(async ({ handle }) => {
        try {
          const response = await fetch(productUrl(root, handle, true), {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return null;
          const product = await response.json();
          return product?.handle === handle && validHandle(product.handle) ? product : null;
        } catch {
          return null;
        }
      }))).filter(Boolean);
      if (products.length === 0) return;

      const list = section.querySelector('[data-zoria-recent-list]');
      list.replaceChildren(...products.map((product) => createCard(section, product, root)));
      section.hidden = false;
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-zoria-recently-viewed]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
